import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import store from './app/store';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import App from './App'
import * as serviceWorker from './serviceWorker';
import { readEnvVars } from './components/Common/envVarsReader';


readEnvVars().then(() => {
  const rootElement = document.getElementById('root');
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <CookiesProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </CookiesProvider>
    </StrictMode>
)})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();